import React, { useState, useEffect } from 'react';

// Libs
import { useCookies } from 'react-cookie';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Button from '@habitech/ui-button';

const Cookies = ({ description }) => {
  const [cookies, setCookie] = useCookies(['']);
  const [showConsentBanner, setShowConsentBanner] = useState(true);

  useEffect(() => {
    setShowConsentBanner(!cookies.HabiCookieConsent);
  }, []);

  const handleClickAuthorize = () => {
    setCookie('HabiCookieConsent', true, {
      path: '/',
      maxAge: 260000,
    });
    setShowConsentBanner(false);
  };

  if (!showConsentBanner) {
    return null;
  }
  return (
    <div id='Cookies' data-testid='Cookies-Wrapper' className='cookiesWrapper'>
      <p className='cookiesWrapper__textCookies'>{parse(description)}</p>
      <Button
        dataId='Cookies-Btn-Accept-Cookies'
        onClick={handleClickAuthorize}
        size='small'
        type='submit'
        variant='stroke'
      >
        Aceptar
      </Button>
    </div>
  );
};

Cookies.propTypes = {
  description: PropTypes.string,
};

Cookies.defaultProps = {
  description: '',
};

export default Cookies;
